import * as Yup from 'yup';

export const termsSchema = Yup.object().shape({
  url: Yup.string().required('URL é obrigatória.'),
  notes: Yup.string()
});